import { render, staticRenderFns } from "./UpdateTasteCard.vue?vue&type=template&id=cb3a416a"
import script from "./UpdateTasteCard.vue?vue&type=script&lang=js"
export * from "./UpdateTasteCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports